import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ClientAccount } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = {
  targetLanguageCodes: string[]; //"en", "en_GB",
  languagePairs: string[]; //'de-nl_NL', 'de-pl',
  styleGuides: {
    referenceId: number;
    name: string;
  }[];
};

type Payload = ClientAccount;

export const useContentGenerationInfo = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query contentGenerationInfo {
      clientAccount {
        allOrderableSourceLanguages {
          code
        }
        allOrderableTargetLanguages {
          code
        }
        languagePairs {
          sourceLanguageCode
          targetLanguageCode
        }
        styleGuides {
          referenceId
          name
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['contentGenerationInfo'],
    queryFn: async () => {
      const response: Payload = await client.request({
        data: {
          gql: graphql
        }
      });

      return {
        targetLanguageCodes: response.allOrderableTargetLanguages?.map((lang) => lang.code),
        languagePairs: response.languagePairs?.map(
          (pair) => `${pair.sourceLanguageCode}-${pair.targetLanguageCode}`
        ),
        styleGuides: response.styleGuides
      };
    }
  });
};
